import {
  CCol,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CLoadingButton,
  CDatePicker,
  CMultiSelect,
  CFormTextarea,
} from '@coreui/react-pro'
import React, { useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import AdsManagerService from 'src/service/AdsManagerService'
import ToastComponent from 'src/components/common/TaostComponent'
import PreviewImage from '../PreviewImage'
const AddForm = (props) => {
  const [loader, setLoader] = useState(false)
  const SUPPORTED_FORMATS = ['image/jpg', 'image/png', 'image/jpeg', 'image/gif']
  const validationSchema = Yup.object().shape({
    title: Yup.string()
      .required('Promo Title is required')
      .max(50, '50 Character Limit is allowed.'),
    validity_date: Yup.string()
      .required('Promo Validity date is required')
      .max(50, '50 Character Limit is allowed.'),
    placement: Yup.array()
      .min(1, 'Please select at least one promo placement')
      .required('Placement is required'),
    design_type: Yup.string()
      .required('Promo Label is required')
      .max(50, '50 Character Limit is allowed.'),
    description: Yup.string()
      .required('Promo Description is required')
      .test('word-limit', 'Maximum 50 words are allowed.', (value) => {
        if (!value) return true

        const wordCount = value
          .trim()
          .split(/\s+/)
          .filter((word) => word.length > 0).length

        return wordCount <= 50
      }),
    image: Yup.mixed()
      .nullable()
      .required('Required Field')
      .test(
        'size',
        'File size too large, max file size is 5 Mb',
        (value) => value && value.size <= 1024 * 1024, // 5MB
      )
      .test(
        'type',
        'Invalid file format selection',
        (value) =>
          // console.log(value);
          !value || (value && SUPPORTED_FORMATS.includes(value?.type)),
      ),
    logo: Yup.mixed()
      .nullable()
      .required('Required Field')
      .test(
        'size',
        'File size too large, max file size is 5 Mb',
        (value) => value && value.size <= 1024 * 1024, // 5MB
      )
      .test(
        'type',
        'Invalid file format selection',
        (value) =>
          // console.log(value);
          !value || (value && SUPPORTED_FORMATS.includes(value?.type)),
      ),
  })
  const formik = useFormik({
    initialValues: {
      title: '',
      design_type: '',
      cta_text: '',
      cta_url: '',
      primary_color: '',
      secondary_color: '',
      validity_date: '',
      description: '',
      hex_code_primary_color: '',
      hex_code_secondary_color: '',
      schedule_start_date: null,
      schedule_end_date: null,
      image: null,
      logo: null,
      placement: [],
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (data, actions) => {
      var formData = new FormData()
      formData.append('title', data.title)
      formData.append('promo_label', data.design_type)
      formData.append('cta_text', data.cta_text)
      formData.append('primary_color', data.primary_color)
      formData.append('secondary_color', data.secondary_color)
      formData.append('validity_date', data.validity_date)
      formData.append('cta_url', data.cta_url)
      formData.append('schedule_start_date', data.schedule_start_date)
      formData.append('schedule_end_date', data.schedule_end_date)
      formData.append('image', data.image)
      formData.append('logo', data.logo)
      formData.append('description', data.description)
      formData.append('placement', JSON.stringify(data.placement))
      setLoader(true)
      AdsManagerService.saveAd(formData)
        .then((res) => {
          if (res.status === 200) {
            props.fetchUsers?.()
            ToastComponent(res.message, 'success')
            setLoader(false)
          } else {
            setLoader(false)
            ToastComponent(res.message, 'error')
          }
        })
        .catch((e) => {
          console.log('error', e)
          setLoader(false)
        })
    },
  })

  const options = [
    { value: 'home', text: 'Home' },
    { value: 'my_team', text: 'My Team' },
    { value: 'players', text: 'Players' },
    { value: 'rankings', text: 'Rankings' },
  ]

  const [selectedValue, setSelectedValue] = useState([])

  const handleChange = (selected) => {
    setSelectedValue(selected.map((item) => item.value))
  }
  return (
    <>
      <CForm className="row g-3" onSubmit={formik.handleSubmit}>
        <CCol md={6}>
          <CFormLabel className="fw-bold" htmlFor="name">
            Promo Title *
          </CFormLabel>
          <CFormInput
            placeholder="Promo Title"
            className={
              'form-control' + (formik.errors.title && formik.touched.title ? ' is-invalid' : '')
            }
            value={formik.values.title}
            onChange={formik.handleChange}
            aria-label="title"
            id="title"
          />
          {formik.errors.title && formik.touched.title && (
            <CFormFeedback invalid>{formik.errors.title}</CFormFeedback>
          )}
        </CCol>
        <CCol md={6}>
          <CFormLabel className="fw-bold" htmlFor="design_type">
            Promo Label *
          </CFormLabel>

          <CFormInput
            placeholder="Promo Label"
            className={
              'form-control' +
              (formik.errors.design_type && formik.touched.design_type ? ' is-invalid' : '')
            }
            value={formik.values.design_type}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            aria-label="design_type"
            id="design_type"
            name="design_type"
          />

          {formik.errors.design_type && formik.touched.design_type && (
            <CFormFeedback invalid>{formik.errors.design_type}</CFormFeedback>
          )}
        </CCol>
        <CCol md={12}>
          <CFormLabel className="fw-bold" htmlFor="description">
            Promo Details *
          </CFormLabel>

          <CFormTextarea
            placeholder="Promo Details"
            className={
              'form-control' +
              (formik.errors.description && formik.touched.description ? ' is-invalid' : '')
            }
            value={formik.values.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            aria-label="description"
            id="description"
            name="description"
            rows={4}
          />

          {formik.errors.description && formik.touched.description && (
            <CFormFeedback invalid>{formik.errors.description}</CFormFeedback>
          )}
        </CCol>
        <CCol md={6}>
          <CFormLabel className="fw-bold" htmlFor="formFile">
            Promo Image (Dimesion: 330 px x 120 px)*
          </CFormLabel>
          <CFormInput
            type="file"
            id="formFile"
            name="image"
            className={
              formik.touched.image
                ? formik.errors.image
                  ? 'form-control input_user is-invalid'
                  : 'form-control input_user is-valid'
                : 'form-control'
            }
            onChange={(event) => {
              formik.setTouched({
                ...formik.touched,
                image: true,
              })
              formik.setFieldValue('image', event.target.files[0])
            }}
          />
          {formik.touched.image && formik.errors.image ? (
            <CFormFeedback invalid>{formik.errors.image}</CFormFeedback>
          ) : null}
          <br></br>
          {formik.values.image ? (
            <PreviewImage
              className={{ margin: 'auto' }}
              width={100}
              height={100}
              file={formik.values.image}
            />
          ) : null}
        </CCol>
        <CCol md={6}>
          <CFormLabel className="fw-bold" htmlFor="formFile">
            Promo Logo (Dimesion: 500 px x 500 px)*
          </CFormLabel>
          <CFormInput
            type="file"
            id="formFile"
            name="logo"
            className={
              formik.touched.logo
                ? formik.errors.logo
                  ? 'form-control input_user is-invalid'
                  : 'form-control input_user is-valid'
                : 'form-control'
            }
            onChange={(event) => {
              formik.setTouched({
                ...formik.touched,
                logo: true,
              })
              formik.setFieldValue('logo', event.target.files[0])
            }}
          />
          {formik.touched.logo && formik.errors.logo ? (
            <CFormFeedback invalid>{formik.errors.logo}</CFormFeedback>
          ) : null}
          <br></br>
          {formik.values.logo ? (
            <PreviewImage
              className={{ margin: 'auto' }}
              width={100}
              height={100}
              file={formik.values.logo}
            />
          ) : null}
        </CCol>
        <CCol md={6}>
          <CFormLabel className="fw-bold" htmlFor="website">
            Promo CTA Text
          </CFormLabel>
          <CFormInput
            placeholder="Promo CTA Text"
            classwebsite={
              'form-control' +
              (formik.errors.cta_text && formik.touched.cta_text ? ' is-invalid' : '')
            }
            value={formik.values.cta_text}
            onChange={formik.handleChange}
            aria-label="cta_text"
            id="cta_text"
          />
          {formik.errors.cta_text && formik.touched.cta_text && (
            <CFormFeedback invalid>{formik.errors.cta_text}</CFormFeedback>
          )}
        </CCol>
        <CCol md={6}>
          <CFormLabel className="fw-bold" htmlFor="website">
            Promo CTA Link
          </CFormLabel>
          <CFormInput
            placeholder="Promo CTA Link"
            classwebsite={
              'form-control' +
              (formik.errors.cta_url && formik.touched.cta_url ? ' is-invalid' : '')
            }
            value={formik.values.cta_url}
            onChange={formik.handleChange}
            aria-label="cta_url"
            id="cta_url"
          />
          {formik.errors.cta_url && formik.touched.cta_url && (
            <CFormFeedback invalid>{formik.errors.cta_url}</CFormFeedback>
          )}
        </CCol>

        <CCol md={3}>
          <CFormLabel className="fw-bold" htmlFor="primary_color">
            Primary Color
          </CFormLabel>

          <CFormInput
            type="color"
            className={
              'form-control' +
              (formik.errors.primary_color && formik.touched.primary_color ? ' is-invalid' : '')
            }
            value={formik.values.primary_color || '#000000'}
            onChange={formik.handleChange}
            name="primary_color"
            id="primary_color"
          />

          {formik.errors.primary_color && formik.touched.primary_color && (
            <CFormFeedback invalid>{formik.errors.primary_color}</CFormFeedback>
          )}
        </CCol>

        <CCol md={3} xs={3}>
          <label htmlFor="primary_hex" className="fw-bold">
            Primary Hex Code
          </label>

          <CFormInput
            type="text"
            className="form-control"
            name="primary_color"
            id="primary_hex"
            value={formik.values.primary_color || '#000000'}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder="#000000"
          />
        </CCol>
        <CCol md={3}>
          <CFormLabel className="fw-bold" htmlFor="secondary_color">
            Secondary Color
          </CFormLabel>

          <CFormInput
            type="color"
            className={
              'form-control' +
              (formik.errors.secondary_color && formik.touched.secondary_color ? ' is-invalid' : '')
            }
            value={formik.values.secondary_color || '#000000'}
            onChange={formik.handleChange}
            name="secondary_color"
            id="secondary_color"
          />

          {formik.errors.secondary_color && formik.touched.secondary_color && (
            <CFormFeedback invalid>{formik.errors.secondary_color}</CFormFeedback>
          )}
        </CCol>

        <CCol md={3} xs={3}>
          <label htmlFor="secondary_hex" className="fw-bold">
            Secondary Hex Code
          </label>

          <CFormInput
            type="text"
            className="form-control"
            name="secondary_color"
            id="secondary_hex"
            value={formik.values.secondary_color || '#000000'}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder="#000000"
          />
        </CCol>

        <CCol md={6}>
          <CFormLabel className="fw-bold">Promo Start Date</CFormLabel>

          <CDatePicker
            locale="en-GB"
            inputDateFormat={(date) => {
              const day = String(date.getDate()).padStart(2, '0')
              const month = String(date.getMonth() + 1).padStart(2, '0')
              const year = date.getFullYear()

              return `${day}/${month}/${year}`
            }}
            placeholder="DD/MM/YYYY"
            date={formik.values.schedule_start_date || null}
            onDateChange={(date) => {
              if (date) {
                const year = date.getFullYear()
                const month = String(date.getMonth() + 1).padStart(2, '0')
                const day = String(date.getDate()).padStart(2, '0')

                const formattedDate = `${year}-${month}-${day}`

                formik.setFieldValue('schedule_start_date', formattedDate)
              } else {
                formik.setFieldValue('schedule_start_date', '')
              }
            }}
          />

          {formik.errors.schedule_start_date && formik.touched.schedule_start_date && (
            <CFormFeedback invalid className="d-block">
              {formik.errors.schedule_start_date}
            </CFormFeedback>
          )}
        </CCol>

        <CCol md={6}>
          <CFormLabel className="fw-bold">Promo End Date</CFormLabel>

          <CDatePicker
            locale="en-GB"
            inputDateFormat={(date) => {
              const day = String(date.getDate()).padStart(2, '0')
              const month = String(date.getMonth() + 1).padStart(2, '0')
              const year = date.getFullYear()

              return `${day}/${month}/${year}`
            }}
            placeholder="DD/MM/YYYY"
            minDate={formik.values.schedule_start_date || undefined}
            date={formik.values.schedule_end_date || null}
            onDateChange={(date) => {
              if (date) {
                const year = date.getFullYear()
                const month = String(date.getMonth() + 1).padStart(2, '0')
                const day = String(date.getDate()).padStart(2, '0')

                const formattedDate = `${year}-${month}-${day}`

                formik.setFieldValue('schedule_end_date', formattedDate)
              } else {
                formik.setFieldValue('schedule_end_date', '')
              }
            }}
          />

          {formik.errors.schedule_end_date && formik.touched.schedule_end_date && (
            <CFormFeedback invalid className="d-block">
              {formik.errors.schedule_end_date}
            </CFormFeedback>
          )}
        </CCol>
        <CCol md={6}>
          <CFormLabel className="fw-bold" htmlFor="validity_date">
            Promo Validity *
          </CFormLabel>

          <CDatePicker
            inputDateFormat={(date) => {
              const day = String(date.getDate()).padStart(2, '0')
              const month = String(date.getMonth() + 1).padStart(2, '0')
              const year = date.getFullYear()

              return `${day}/${month}/${year}`
            }}
            placeholder="DD/MM/YYYY"
            locale="en-US"
            date={formik.values.validity_date || null}
            onDateChange={(date) => {
              if (date) {
                const year = date.getFullYear()
                const month = String(date.getMonth() + 1).padStart(2, '0')
                const day = String(date.getDate()).padStart(2, '0')

                const formattedDate = `${year}-${month}-${day}`

                formik.setFieldValue('validity_date', formattedDate)
              } else {
                formik.setFieldValue('validity_date', '')
              }
            }}
            onBlur={() => formik.setFieldTouched('validity_date', true)}
            className={
              formik.errors.validity_date && formik.touched.validity_date ? 'is-invalid' : ''
            }
          />

          {formik.errors.validity_date && formik.touched.validity_date && (
            <div className="invalid-feedback d-block">{formik.errors.validity_date}</div>
          )}
        </CCol>
        <CCol md={6}>
          <CFormLabel className="fw-bold" htmlFor="placement">
            Promo Placement*
          </CFormLabel>

          <CMultiSelect
            id="placement"
            options={options}
            selectionType="tags"
            name="placement"
            value={formik.values.placement || []}
            onChange={(value) => {
              formik.setFieldValue('placement', value)
            }}
            onBlur={() => formik.setFieldTouched('placement', true)}
            className={formik.errors.placement && formik.touched.placement ? 'is-invalid' : ''}
          />

          {formik.errors.placement && formik.touched.placement && (
            <div className="invalid-feedback d-block">{formik.errors.placement}</div>
          )}
        </CCol>
        <CCol md={6}>
          <CLoadingButton type="submit" color="success" variant="outline" loading={loader}>
            Submit
          </CLoadingButton>
        </CCol>
      </CForm>
    </>
  )
}

export default AddForm
